/** @format */

import {Alert, AlertDescription, AlertIcon, Box} from '@chakra-ui/react';
import React from 'react';
import {fonts} from '../../styles/js/fonts';

export const MutationFormMessage = ({messages}: {
	messages: string[];
}) => {
	if (messages.length > 0 && messages[0] !== '') {
	  return (
			<Box my={4}>
		  		{messages.map((message, index) => (
					<Alert key={index} status='error'>
			  			<AlertIcon />
			  			<AlertDescription fontFamily={fonts.base}>
							{message}
						</AlertDescription>
					</Alert>
		  		))}
			</Box>
	  );
	}

	return null;
};
